query GetSageJournalEntry($id: ID!) {
  sageJournalEntry(id: $id) {
    id
    lastSageSyncDate
    accountNumber
    accountTitle
    txnAmount {
      minorUnit
      currency
    }
    amountIssue
    batchDate
    batchNumber
    batchTitle
    batchReference
    caseRecord {
      id
      description
      caseNumber
      transactionDate
    }
    caseAmount {
      minorUnit
      currency
    }
    classId
    className
    currencyIssue
    dateIssue
    description
    entryDate
    exchangeRate
    exchangeRateDate
    fundAccountIssue
    location
    locationName
    numberOfIssues
    sageGiftAccount {
      id
      name
      sageId
      fundAccount {
        id
        currency
        fund {
          id
          name
          legalEntity {
            id
            name
          }
        }
      }
    }
    caseLegalEntity
    sageId
    state
    transactionType
    whenCreated
    whenModified
    legalEntityIssue
    caseFundAccount {
      id
      currency
      sageCode
      fund {
        id
        name
        legalEntity {
          id
          name
        }
      }
    }
  }
}
